@if (isLoading$ | async) {
  <div class="loader">
    <app-loader></app-loader>
  </div>
}
<div mat-dialog-title>
  <h2>{{ 'mfa.setupTitle' | translate }}</h2>
</div>
<mat-dialog-content>
  @if (!loggedInUser) {
    @if (setupData; as data) {
      <p>{{ 'mfa.scanInstructions' | translate }}</p>
      <img
        [src]="'data:image/png;base64,' + data.qrCodeBase64"
        alt="MFA QR code" />
      <p class="mfa-manual-secret">
        {{ 'mfa.manualEntry' | translate }}: <code>{{ data.secret }}</code>
      </p>

      <form [formGroup]="confirmForm" (ngSubmit)="confirmCode()">
        <mat-form-field>
          <mat-label>{{ 'mfa.code' | translate }}</mat-label>
          <input
            matInput
            formControlName="code"
            maxlength="6"
            autocomplete="one-time-code" />
          @if (
            confirmForm.get('code')?.invalid && confirmForm.get('code')?.touched
          ) {
            <mat-error>{{ 'mfa.invalidCode' | translate }}</mat-error>
          }
        </mat-form-field>
        <div class="dialog__buttons">
          <button
            type="submit"
            class="primary-button"
            [disabled]="confirmForm.invalid">
            {{ 'shared.confirm' | translate }}
          </button>
        </div>
      </form>
    }
  } @else {
    <p class="mfa-backup-warning">{{ 'mfa.backupCodesWarning' | translate }}</p>
    <ul class="mfa-backup-codes">
      @for (code of loggedInUser!.backupCodes; track code) {
        <li>
          <code>{{ code }}</code>
        </li>
      }
    </ul>
    <div class="dialog__buttons">
      <button type="button" class="primary-button" (click)="close()">
        {{ 'mfa.savedCodes' | translate }}
      </button>
    </div>
  }
</mat-dialog-content>
